import graphql from "babel-plugin-relay/macro";

export default graphql`
  query getEventsV2Query($propertyId: ID!, $startAt: String, $endAt: String, $type: String) {
    hyevents(propertyId: $propertyId, startAt: $startAt, endAt: $endAt, type: $type) {
      edges {
        cursor
        node {
          id
          title
          startAt
        }
      }
    }
  }
`;
